import checkLatestDaily from './latestDaily';
// This should return an object with two properties:
// - source: A string of text to be filled with any placeholders
// - context: An object with an variables to fill the placeholders in source
const getSmartText = (globalStatistics, caseCounts, country, locale, smartText) => {
  const latestDaily = checkLatestDaily(globalStatistics, caseCounts, country, locale, smartText.latestDaily);
  return latestDaily;
};

export default getSmartText;
